import { render, staticRenderFns } from "./MfOverviewCard.vue?vue&type=template&id=b02af0b8&scoped=true&"
import script from "./MfOverviewCard.vue?vue&type=script&lang=js&"
export * from "./MfOverviewCard.vue?vue&type=script&lang=js&"
import style0 from "./MfOverviewCard.vue?vue&type=style&index=0&id=b02af0b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02af0b8",
  null
  
)

export default component.exports